import React from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { Box } from '@vio/atlas/helpers/Box';
import { PageWidthContainer } from '@vio/atlas/helpers/PageWidthContainer';
import { Text } from '@vio/atlas/Text';
import { SearchFormDesktop } from 'components/SearchBox/Home/SearchFormDesktop';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
const _exp2 = /*#__PURE__*/() => ({
  backgroundImage
}) => `url(${backgroundImage})`;
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wj1jdhg",
  propsAsIs: false,
  vars: {
    "wj1jdhg-0": [_exp2()]
  }
});
const _exp3 = /*#__PURE__*/() => PageWidthContainer;
const Container = /*#__PURE__*/styled(_exp3())({
  name: "Container",
  class: "c1nbmsqv",
  propsAsIs: true
});
const _exp8 = /*#__PURE__*/() => Text;
const Title = /*#__PURE__*/styled(_exp8())({
  name: "Title",
  class: "t1xs7uo2",
  propsAsIs: true
});
const _exp13 = /*#__PURE__*/() => Text;
const Subtitle = /*#__PURE__*/styled(_exp13())({
  name: "Subtitle",
  class: "s3qk0kl",
  propsAsIs: true
});
export const AlternativeDesktopSearchForm: React.FC = () => {
  const {
    brandIsKiwi,
    brandHomepageHeadingMessage,
    brandHomepageSubheadingMessage
  } = useBrand();
  const assetsEndpoint = process.env.NEXT_PUBLIC_ASSETS_ENDPOINT;
  const heroImgName = brandIsKiwi && `${assetsEndpoint}static/kiwi-web-hero.png`;
  return <Wrapper backgroundImage={heroImgName}>
      <Container paddingDesktopXsSize="s500" paddingMobileSmSize="s400" className={cx(brandIsKiwi && '__isKiwi')}>
        <Box marginBottom="s800">
          {brandHomepageHeadingMessage && <Title variant="title4XL" dataId="HomeHeading" colorPath="homepage.heading.content" className={cx(brandIsKiwi && '__isKiwi')}>
              <FormattedMessageWrapper {...brandHomepageHeadingMessage} />
            </Title>}

          {brandHomepageSubheadingMessage && <Subtitle variant="labelM" colorPath="homepage.heading.content">
              <FormattedMessageWrapper {...brandHomepageSubheadingMessage} />
            </Subtitle>}
        </Box>
        <Box backgroundColor="homepage.form.background" borderRadius="lg" padding="s600">
          <SearchFormDesktop />
        </Box>
      </Container>
    </Wrapper>;
};

require("./AlternativeDesktopSearchForm.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./AlternativeDesktopSearchForm.tsx");